var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('el-tabs',{staticClass:"elTabs",on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('product-first')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }